import { render, staticRenderFns } from "./DoctorChoice.vue?vue&type=template&id=2c462274"
import script from "./DoctorChoice.vue?vue&type=script&lang=js"
export * from "./DoctorChoice.vue?vue&type=script&lang=js"
import style0 from "./DoctorChoice.vue?vue&type=style&index=0&id=2c462274&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports